export const pluginConfig = {
  lang: 'id',
  position: 'bottom-left',
  offset: [20, 20],
  size: 58,
}
